import { Model, ServiceType } from ".";

export default class Service extends Model {
	get singularNoun() {
		return "service";
	}

	get mutations() {
		return {
			serviceType: ServiceType
		};
	}

	resource() {
		return "services";
	}
}
